import { CloseOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal, } from "antd"
import { useEffect, useRef } from "react"
import { useForm } from "antd/es/form/Form"
import { editColorCarGroup, ICarColorGroup } from "../../../../api/colorCar/colorCarApi"
interface ModalProps {
  isOpen: boolean
  infoGroupColor?: ICarColorGroup
  onSubmitFormModalEdit?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: (value: boolean) => void
}
const ModalEditGroupColorCar: React.FC<ModalProps> = ({
  isOpen, infoGroupColor,
  onSubmitFormModalEdit, closeModal
}) => {
  const [form] = useForm();
  const title = infoGroupColor?.title.toLocaleLowerCase()
  const inputRef = useRef<FormInstance>(null);
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const result = await editColorCarGroup(Number(infoGroupColor?.id), values.namegroupcolor)
    if (result?.status) {
      onSubmitFormModalEdit?.(true, result?.message)
    } else {
      onSubmitFormModalEdit?.(false, result?.message)
    }
  };

  useEffect(() => {
    if (isOpen) {
      form.setFieldValue('namegroupcolor', infoGroupColor?.title)
    } else {
      form.resetFields()
    }
  }, [isOpen])
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">
          Chỉnh sửa màu xe

        </span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
      </div>}
      open={isOpen}
      onCancel={() => closeModal(false)}
      centered
      className="w-modal modal-content ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
        <span className="text-sm text-98A2B3 cursor-pointer" onClick={() => closeModal(false)}>Huỷ</span>
        <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
          onClick={submitForm}>
          Chỉnh sửa màu xe
        </button>
      </div>}
    >
      <div className="p-6 ">
        <Form
          form={form}
          ref={inputRef}
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          <Form.Item
            name="namegroupcolor"
            rules={[{ required: true, message: 'Nhập tên màu xe' }]}
            className="m-none-form-item text-explan"
          >
            <Input
              placeholder='Nhập tên màu xe'
              className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
            />
          </Form.Item>
        </Form>

      </div>
    </Modal>
  )
}
export default ModalEditGroupColorCar
